export default {
	data() {
		return {
			moduleName: 'brands',
			detailPageRouteName: 'brandDetail',
			formIsValid: true,
			entity: {},
			updateFields: [
				'name',
				'code',
				'apple_store_url',
				'google_store_url',
				'microsoft_store_url',
				'qr_code_pairing_url_template',
				'note',
				'allow_pair_devices_from_other_brands_when_static_brand_configured',
				'liveweb_settings'
			],
		}
	},
	methods: {
		resetFields() {
			this.$refs['basicinforef'].$refs['nameref'].setForcedInvalid(false);
			this.$refs['basicinforef'].$refs['coderef'].setForcedInvalid(false);

			this.processErrorMessage({'validation_errors': [], 'error_message': ''})
		},
		_processDetailErrorMessage(error) {
			this.resetFields();

			return this.processErrorMessage(error)
		},
		processErrorMessage(error) {
			let errorMessage = null;
			this.$refs['basicinforef'].validateFormRequiredFields()

			this._.forEach(error['validation_errors'], function (message) {
				errorMessage = message;

				if (message.match("^Name \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Název brandu musí být unikátní.');
					this.$refs['basicinforef'].$refs['nameref'].setForcedInvalid(true, this.$gettext('Název není unikátní'));
				} else if (message.match("^STB code \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Kód brandu musí být unikátní.');
					this.$refs['basicinforef'].$refs['coderef'].setForcedInvalid(true, this.$gettext('Kód není unikátní'));
				} else if (message === "Code can contains only alphanumeric characters, dash and underscore!") {
					errorMessage = this.$gettext("Kód smí obsahovat pouze znaky [a-ZA-Z0-9-_].");
					this.$refs['basicinforef'].$refs['coderef'].setForcedInvalid(true, this.$gettext('Kód smí obsahovat pouze znaky [a-ZA-Z0-9-_].'));
				} else if (message === "Unable to delete brand assigned to operator.") {
					errorMessage = this.$gettext("Brand nelze smazat - je přiřazen operátorům.");
				}
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/views/brands/mixins/brands.js